import { aggregationFns } from '@tanstack/react-table';
export const MRT_AggregationFns = Object.assign({}, aggregationFns);
//# sourceMappingURL=aggregationFns.js.map